<template>
 <v-dialog v-model="dialogViewer" v-if="this.resultado" fullscreen transition="dialog-bottom-transition" :overlay="false" scrollable>
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-btn icon @click.native="close()" dark>
            <v-icon>arrow_back</v-icon>
          </v-btn>
            <v-toolbar-title>{{this.resultado.nomePaciente}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon :href="linkDownload">
            <v-icon>file_download</v-icon>
          </v-btn>
        </v-toolbar>

        <div style="height:100%; overflow: hidden;" >
          <iframe v-if="loaded" :id="`viframe_${resultado.id}`" frameborder="0" width="100%" height="100%"></iframe>
        </div>
      </v-card>
      
    </v-dialog>

</template>

<script>
export default {

  name: 'viewer-dialog',
  props: {
    resultado: {},
    display: false,
    link: ''
  },
  data () {
    return {
      dialogViewer: false,
      loaded: false,
      linkViewer: '',
      nomePaciente: '',
      linkDownload: ''
    }
  },
  components: {
  },
  watch: {
    display (value) {
      this.dialogViewer = value
    },
    resultado () {
      this.popularDados()
    },
    link () {
      if (this.link) {
        console.log('iframe cargado... ' + this.link)
        var iframe = document.getElementById(`viframe_${this.resultado.id}`)
        iframe.src = this.link
        iframe.onload = function () {
          console.log('loaded... ')
        }
      }
    }
  },
  methods: {
    close () {
      this.dialogViewer = false
      this.$emit('update:display', false)
    },
    popularDados () {
      if (this.resultado) {
        this.nomePaciente = this.resultado.nomePaciente
        this.linkDownload = `https://storage.googleapis.com/${this.resultado.intervaloStorage}/${this.resultado.idConnect}/${this.resultado.idConnect}.zip`
      }
    }
  },
  created () {
  },
  mounted () {
    // this.linkViewer = this.link
    this.popularDados()
    this.loaded = true
  }

}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// ViewerDialog.vue?33ed55dc